import Vue from 'vue'
import Router from 'vue-router'

import home from '@/pages/home'
import index from '@/pages/index'
import yhdl from '@/pages/yhdl/yhdl'
import zc from '@/pages/zc/zc'
const xmal = r => require.ensure([], () => r(require('@/pages/xmal/xmal')), 'xmal') 
const xmalone = r => require.ensure([], () => r(require('@/pages/xmal/xmalone')), 'xmal') 
const xmaltwo = r => require.ensure([], () => r(require('@/pages/xmal/xmaltwo')), 'xmal') 
const xmalthree = r => require.ensure([], () => r(require('@/pages/xmal/xmalthree')), 'xmal') 
const xmalfour = r => require.ensure([], () => r(require('@/pages/xmal/xmalfour')), 'xmal') 
const xmalfive = r => require.ensure([], () => r(require('@/pages/xmal/xmalfive')), 'xmal') 
const xmalsix = r => require.ensure([], () => r(require('@/pages/xmal/xmalsix')), 'xmal') 
const xmalseven = r => require.ensure([], () => r(require('@/pages/xmal/xmalseven')), 'xmal') 
const xmaleight = r => require.ensure([], () => r(require('@/pages/xmal/xmaleight')), 'xmal') 
// 合作共赢
const dgcy = r => require.ensure([], () => r(require('@/pages/jmhz/dgcy')), 'dgcy')
const pphz = r => require.ensure([], () => r(require('@/pages/jmhz/pphz')), 'pphz')
const zypphz = r => require.ensure([], () => r(require('@/pages/jmhz/zypphz')), 'zypphz')
// 智能运维
const dlyy = r => require.ensure([], () => r(require('@/pages/znyw/dlyy')), 'dlyy')
const nygl = r => require.ensure([], () => r(require('@/pages/znyw/nygl')), 'nygl')
// 产品中心
const znyj = r => require.ensure([], () => r(require('@/pages/cpzx/znyj')), 'znyj')
const bdgj = r => require.ensure([], () => r(require('@/pages/cpzx/bdgj')), 'bdgj')
const njb = r => require.ensure([], () => r(require('@/pages/cpzx/njb')), 'njb')
// 底部
const lxwm = r => require.ensure([], () => r(require('@/pages/foot/lxwm')), 'lxwm')
const qyjs = r => require.ensure([], () => r(require('@/pages/foot/qyjs')), 'qyjs')
const xwdt = r => require.ensure([], () => r(require('@/pages/foot/xwdt')), 'xwdt')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta: {
        title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
      }
    },
    {
      path: '/index/yhdl',
      name: 'yhdl',
      component: yhdl,
      meta: {
        title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
      }
    },
    {
      path: '/index/zc',
      name: 'zc',
      component: zc,
      meta: {
        title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
      }
    },
    {
      path: '/',
      name: 'index/home',
      component: index,
      children: [
        {
          path: '/index/qyjs',
          component: qyjs,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/xwdt',
          component: xwdt,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/lxwm',
          component: lxwm,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/njb',
          component: njb,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/znyj',
          component: znyj,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/bdgj',
          component: bdgj,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/nygl',
          component: nygl,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/dlyy',
          component: dlyy,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/dgcy',
          component: dgcy,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/pphz',
          component: pphz,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/zypphz',
          component: zypphz,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/xmal',
          component: xmal,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/xmalone',
          component: xmalone,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/xmaltwo',
          component: xmaltwo,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/xmalthree',
          component: xmalthree,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/xmalfour',
          component: xmalfour,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/xmalfive',
          component: xmalfive,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/xmalsix',
          component: xmalsix,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/xmalseven',
          component: xmalseven,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
        {
          path: '/index/xmaleight',
          component: xmaleight,
          meta: {
            title: '智能配电房运维改造-能耗监测-能监宝-浙江新能量科技股份有限公司',
          }
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js